import React, { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import useAPI from '../../../api';
import { Button, Typography } from '@mui/material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import FiltersNavbarWrapper from '../../../Components/Filters/FiltersNavbarWrapper';
import { CenteredFlexBox, FullSizeColumn } from '../../../Components/FlexBox';
import BranchesReportSelect from '../../../Components/Inputs/BranchesReportSelect';
import ReportSelect from '../../../Components/Inputs/ReportSelect';
import mapFilters from '../../../Helpers/Filters/mapFilters';
import ThemeFab from '../../../Components/Button/ThemeFab';
import Fab from '../../../Components/Navbar/Fab';

const FiltersNavbar = function FiltersNavbar({
  onSubmit,
  defaultBranches = [],
  defaultCampaign = '',
}) {
  const API = useAPI();
  const intl = useIntl();

  const hasSubmitted = useRef(false);
  const [open, setOpen] = useState(true);
  const [branches, setBranches] = useState(defaultBranches);
  const [campaignId, setCampaignId] = useState(defaultCampaign);
  const [campaigns, setCampaigns] = useState([]);

  const handleChangeCampaign = (e) => {
    setCampaignId(e.target.value);
  };

  useEffect(() => {
    setBranches(defaultBranches);
    setCampaignId(defaultCampaign);
  }, [defaultBranches, defaultCampaign]);

  useEffect(() => {
    API.getCommercialCampaignsHistory(
      {
        pageNumber: 1,
        pageSize: 100,
        silent: true,
        filterExpression: mapFilters(
          [],
          [
            {
              keyName: 'isActive',
              operator: 'eq',
            },
          ],
          [],
          { isActive: true }
        ),
        sortExpression: {
          sortValue: 'startDate',
          sort: 'desc',
        },
      },
      (res) => {
        setCampaigns(res);
        setCampaignId(res[0]?.id || null);
      }
    );
  }, []);

  useEffect(() => {
    if (campaignId && branches && !hasSubmitted.current) {
      onSubmit({ branchIds: branches, campaignId });
      hasSubmitted.current = true;
    }
  }, [campaignId, branches, onSubmit]);

  return (
    <FiltersNavbarWrapper
      open={open}
      onToggle={() => setOpen(!open)}
      title="FUNNELREPORT"
    >
      <FullSizeColumn paddingTop="24px">
        <CenteredFlexBox gap="24px" padding="16px 0px">
          <BranchesReportSelect
            value={branches}
            onChange={setBranches}
            allDefault
          />
          <ReportSelect
            label={intl.messages.CAMPAIGN}
            value={campaignId}
            onChange={handleChangeCampaign}
            fullWidth
            padding="30px"
            items={campaigns?.map(({ id, description }) => ({
              label: description,
              value: id,
              active: true,
            }))}
          />
        </CenteredFlexBox>
        <Button
          variant="contained"
          color="primary"
          sx={{ alignSelf: 'flex-end' }}
          onClick={() => {
            onSubmit({
              branchIds: branches,
              campaignId,
            });
          }}
        >
          {intl.messages.CONFIRM}
        </Button>
      </FullSizeColumn>
    </FiltersNavbarWrapper>
  );
};

export default FiltersNavbar;
